import React, { useState } from "react";
import styles from "./FinancialAccessModal.module.css";
import { verifyFinancialPassword } from "../../../../Component/function/FinancialApi";

const FinancialAccessModal = ({
  open,
  onClose,
  onSuccess,
}) => {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  if (!open) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password.trim()) {
      setError("من فضلك أدخل كلمة المرور");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const response = await verifyFinancialPassword(password);

      if (response.data?.statusCode === 200) {
        const financialToken = response.data.data;

        sessionStorage.setItem(
          "financialAccessToken",
          financialToken
        );

        setPassword("");

        onSuccess();
      } else {
        setError(
          response.data?.message || "كلمة المرور غير صحيحة"
        );
      }
    } catch (error) {
      console.error(error);

      setError(
        error.response?.data?.message ||
          "كلمة المرور غير صحيحة"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.overlay}>
      <div className={styles.modal} dir="rtl">
        <button
          className={styles.close}
          onClick={onClose}
          disabled={loading}
        >
          ×
        </button>

        <h2>الدخول إلى القسم المحاسبي</h2>

        <p>
          من فضلك أدخل كلمة مرور القسم المحاسبي
        </p>
        

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={(e) => {
              setPassword(e.target.value);
              setError("");
            }}
            placeholder="كلمة المرور"
            autoFocus
          />

          {error && (
            <div className={styles.error}>
              {error}
            </div>
          )}

          <div className={styles.actions}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
            >
              إلغاء
            </button>

            <button
              type="submit"
              disabled={loading}
            >
              {loading ? "جاري التحقق..." : "دخول"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FinancialAccessModal;